  
import {useContext} from 'react';

  
import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

 
import {InfoBox} from './InfoBox';
import {ReactComponent as Compass} from '../../../../../assets/job_postings/icons/compass.svg';
import {LanguageContext} from '../../../../../contexts/LanguageContext/LanguageContext';
import {DachCountryCodes} from '../../../../../domain/languages';
import {greenColors, orangeColors} from '../../../../../layouts/theme/designSystem';
import {formatStreetAddress} from '../../../../../utils/addressUtils/addressUtils';
import {getDachCountryNameFromCode} from '../../../../../utils/getDachCountryNameFromCode';
import {MatchLocation} from '../../../dashboard/types/ApplicantMatchesTypes';

interface Props {
  locations: MatchLocation[];
}

export const CompanyLocations = ({locations}: Props) => {
  const lang = useContext(LanguageContext);
  const {t} = useTranslation('translation', {
    keyPrefix: 'applicantDashboard.matchDetailsView.companyDetails.location',
  });
  const textColor = orangeColors[100];

  return (
    <Grid
      item
      sx={{
        paddingTop: {xs: '40px', sm: '40px'},
        paddingLeft: {xs: '0px', sm: '0px', md: '32px'},
      }}
    >
      <Typography variant='h3' paddingBottom='32px'>
        {t('title')}
      </Typography>
      <Box display='flex' justifyContent='space-between'>
        <Typography variant='h4' paddingBottom='5px' color={greenColors[700]}>
          {t('thisJob')}
        </Typography>
        <Compass fill={greenColors[100]} />
      </Box>
      {locations.map((location) => (
        <InfoBox
          key={location.id}
          title={getDachCountryNameFromCode(location.isoCode as DachCountryCodes, lang)}
          text={formatStreetAddress(location)}
          color={textColor}
        />
      ))}
    </Grid>
  );
};
